import { DefaultFetchError,
  FetchCreate,
  FetchDelete,
  FetchGet,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate,
  useFetchDelete,
  useFetchGet,
  useFetchGetId,
  useFetchUpdate } from '../fetch';
import { FileData } from './files';
import { User } from '../../store/auth';
import { Comment } from '../../store/comment';
import { CategoryShort } from './categories';
import { SubCategoryShort } from './subCategories';
import { Article } from '../../store/article';
import { Business } from '../../store/business';

export enum PostStatus {
  PUBLISHED = 'published',
  DEACTIVATED = 'deactivated',
  DRAFT = 'draft',
}

export enum PostType {
  BUSINESS = 'business',
  ARTICLE = 'article',
  INTERNATIONAL_COMMUNITY = 'international_community',
  CATEGORY = 'category',
  SUBCATEGORY = 'subcategory',
}

export interface PostShort {
  id: string;
  isActive: boolean;
  status: PostStatus;
  entity: PostType;
  text: string;
  numberOfLikes: number;
  numberOfDislikes: number;
  numberOfComments: number;
  numberOfCommentsTotal: number;
  files: FileData[];
  category: CategoryShort;
  subCategory: SubCategoryShort;
  article: Article;
  business: Business;
  comments: Comment[];
  user: User | null;
  createdAt: string;
}

export enum PostOrderColumn {
  ID = 'id',
  LIKE = 'numberOfLikes',
  DISLIKE = 'numberOfDislikes',
  MOST_COMMENTED = 'mostCommented',
  CREATED = 'createdAt',
  UPDATED = 'updatedAt',
}

export interface PostsGetParams extends PagingParams {
  orderByColumn?: PostOrderColumn;
}

export const usePostsGet = (): FetchGet<
  PagingDataResponse<PostShort>,
  PostsGetParams
> => useFetchGet(
  'admin/posts',
  {
    autoStart: false,
    startStateLoading: false,
  },
);

// export const usePostsForSelectGet = (): FetchGet<
//   Pick<PostShort, 'id'>[],
//   PostsGetParams
// > => useFetchGet(
//   'posts/for-select',
//   {
//     autoStart: false,
//     startStateLoading: false,
//   },
// );

export interface PostById extends PostShort {
  comments: Comment[];
}

export const usePostGetById = (postId?: string): FetchGet<
  PostById
> => useFetchGetId(
  'admin/posts',
  postId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export interface PostCreateResponse {
  isActive: boolean;
  name: string;
  header: string;
  description: string;
  fileId: string;
  author: string;
}

export interface PostCreateData {
  text: string,
  status: PostStatus,
  entity: PostType,
  businessId?: string;
  categoryId?: string;
  subCategoryId?: string;
  articleId?: string;
  fileIds?: string[]
}

export const usePostCreate = (): FetchCreate<
  PostCreateResponse,
  DefaultFetchError,
  PostCreateData
> => useFetchCreate(
  'admin/posts',
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export type PostUpdateResponse = PostCreateResponse;

export interface PostUpdateData extends Partial<PostCreateData> {
  id?: string;
}

export const usePostUpdate = (postId?: string): FetchUpdate<
  PostUpdateResponse,
  DefaultFetchError,
  PostUpdateData
> => useFetchUpdate(
  'admin/posts',
  postId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export const usePostDelete = (postId?: string): FetchDelete => useFetchDelete(
  'admin/posts',
  postId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export default {
  usePostsGet,
  usePostGetById,
  usePostCreate,
  usePostUpdate,
  usePostDelete,
};
